// extracted by mini-css-extract-plugin
export default {"footCon":"Footer_footCon__L2ELw","firstCol":"Footer_firstCol__BvO+O","secCol":"Footer_secCol__DVqVB"};